import React, { useEffect } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { Info } from "@material-ui/icons";
import { useForm } from "react-hook-form";
import { customAPI } from "services/utils/CustomAPI";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { CustomTextBox } from "components/CustomComponents";
import { formKeyText, formRightSideAlign } from "services/constants/Styles";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";
import { showToast } from "services/utils/Status";
import { tooltipStyleProps } from "services/constants/Styles";
export const EditLeaveType = ({
  editLeave,
  setEditLeave,
  setApiCall,
  editLeaveDetails,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({ mode: "onBlur" });
  const { domain } = useSelector((state) => state.tokenReducer);

  useEffect(() => {
    setValue("leave_type", editLeaveDetails?.name);
    setValue("leave_color", editLeaveDetails?.leave_color);
  }, [editLeaveDetails, setValue]);

  const handleLeaveName = (event) => {
    setValue("leave_type", event.target.value);
  };

  const onSubmit = async (data) => {
    const response = await customAPI(
      `${domain}new-leave-type/${editLeaveDetails?.id}/`,
      "PUT",
      {
        name: data?.leave_type,
        leave_color: data?.leave_color,
      }
    );
    if (response.ok) {
      showToast("success", "Leave type updated.");
      setEditLeave(false);
      setApiCall(true);
    }
  };

  return (
    <React.Fragment>
      <GlobalDialogBox
        handleCloseDialog={() => {
          setEditLeave(false);
          reset();
        }}
        open={editLeave}
        title="Edit Leave Type"
        minWidth={600}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Mui.Grid
            container
            sx={{
              padding: 1,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Mui.Grid xs={12} sm={12} md={12} lg={6} xl={6}>
              <Mui.Typography sx={formKeyText}>
                Leave Type
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="This is the First Shift field. Choose the first shift of the day, which could be Morning, Afternoon, or Night, depending on the schedule."
                >
                  &nbsp;
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
              sx={formRightSideAlign}
            >
              <CustomTextBox
                selectedValue={watch("leave_type")}
                rules={{
                  ...register("leave_type", {
                    required: "Leave type is required",
                    minLength: {
                      value: 3,
                      message: "Minium length is 3 characters",
                    },
                    maxLength: {
                      value: 100,
                      message: "Maximum length is 100 characters",
                    },
                    validate: {
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={handleLeaveName}
                placeHolder="Enter leave type name"
                errorMessage={
                  errors?.leave_type?.message ? errors?.leave_type?.message : ""
                }
                textBoxError={errors.leave_type ? true : false}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container sx={{ paddingTop: 1 }}>
            <Mui.Grid xs={6}>
              <Mui.Typography sx={formKeyText}>
                Leave Color &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="This is the colour that appears in the calendar if this leave type is applied. "
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={6}>
              <Mui.TextField
                type="color"
                value={watch("leave_color")}
                {...register("leave_color", {
                  required: false,
                })}
                onChange={(event) => {
                  setValue("leave_color", event.target.value);
                }}
                sx={{
                  "& fieldset": { border: "none" },
                  width: 250,
                }}
                size="small"
                fullWidth
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid
            container
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <CustomButton
              actionFuntion={() => {
                reset();
                setEditLeave(false);
              }}
              actionName="Cancel"
              typeName="button"
            />
            &nbsp;&nbsp;
            <CustomButton actionName="Update" typeName="submit" />
          </Mui.Grid>
        </form>
      </GlobalDialogBox>
    </React.Fragment>
  );
};
